import React from 'react';
import { useTranslation } from 'react-i18next';

import { getThemeLogoById } from '../../theme/theme.utils';
import {
  CoveragePolicyStatus,
} from '../insurance/coverageOverview/CoveragePolicyStatus';

import { MARKETING_CHANNEL_ID } from '../../theme/theme.constants';

import './PolicyListItem.css';
import { formatShortDateByLanguage } from '../../services/language.utils';

const PolicyListItem = ({
  endsOn,
  marketingChannel,
  onClick = () => { },
  policyNumber,
  startsOn,
  status,
  statusId,
  selected = false,
}) => {
  const { t } = useTranslation('insurance');
  const { dark } = getThemeLogoById(marketingChannel);
  const formattedStartDate = startsOn
    ? formatShortDateByLanguage(startsOn) : '-';
  const formattedEndDate = endsOn
    ? formatShortDateByLanguage(endsOn) : '-';

  return (
    <li className="Policy-list-item-container">
      <button data-selected={selected} onClick={onClick} type="button">
        <div className="Policy-list-item-data">
          <img
            alt=""
            className="Policy-list-item-logo"
            data-marketingchannel={marketingChannel}
            src={dark}
          />

          <div className="Policy-list-item-content">
            <div>
              <h3>{t('otherPolicies.policyNumber')}</h3>

              <p>{policyNumber}</p>
            </div>

            <div>
              <h3>
                {marketingChannel !== MARKETING_CHANNEL_ID.figo
                  ? t('coveragePeriod') : t('otherPolicies.policyTerm')}
              </h3>

              <p>{`${formattedStartDate} - ${formattedEndDate}`}</p>
            </div>
          </div>
        </div>

        <CoveragePolicyStatus
          label={status}
          status={statusId}
        />
      </button>
    </li>
  );
};

export { PolicyListItem };
